<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:Invoice No -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">Invoice No :</label>
                <span class="form-control-plaintext">{{ ordInvoiceNo }}</span>
              </div>
            </div>
            <!-- End:Invoice No -->

            <!-- Begin:งบประมาณ input -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">Invoice Date :</label>
                <span class="form-control-plaintext">{{ ordInvoiceDate }}</span>
              </div>
            </div>
            <!-- End:งบประมาณ input -->

            <!-- Begin:Vandor select2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">Supplier :</label>
                <span class="form-control-plaintext">{{ ordSupplier }}</span>
              </div>
            </div>
            <!-- End:ประเภทงบประมาณ select2 -->
          </div>
          <!-- Begin:Picture element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label">แนบไฟล์:</label>
                <div v-show="ordDownloadUrl != null">
                  <span class="form-control-plaintext">{{ ordFileName }}</span>
                  <a :href="ordDownloadUrl" target="_blank">Download</a>
                  <br />
                  <br />
                </div>

                <!-- <span class="form-control-plaintext">{{ordFileName}}</span>
                <a :href="ordDownloadUrl">Download</a>-->
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการสินค้า/ทรัพย์สิน:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">รหัส/ชื่อสินค้า</th>
                        <th class="text-center" width="7%">จำนวน</th>
                        <th class="text-center" width="10%">ราคา</th>
                        <th class="text-center" width="13%">รวม</th>
                        <th class="text-center" width="15%">งบประมาณ</th>
                        <th class="text-center" width="15%">โควต้า</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in ordStocks" :key="i">
                        <td class="text-center stock-item-td">{{ i + 1 }}</td>
                        <td class="stock-item-td">{{ row.materialName }}</td>
                        <td class="text-center stock-item-td">{{ row.qty }}</td>
                        <td class="text-center stock-item-td">
                          {{ row.price | currency("฿", 2) }}
                        </td>
                        <td class="text-center stock-item-td">
                          {{ row.summaryItem | currency("฿", 2) }}
                        </td>
                        <td class="stock-item-td">{{ row.budgetName }}</td>
                        <td class="stock-item-td">{{ row.quotaName }}</td>
                      </tr>
                      <tr>
                        <td class="text-center" colspan="2">Total</td>
                        <td class="text-center">
                          {{ oddTotalQty | currency("", 0) }}
                        </td>
                        <td class="text-center">
                          {{ oddTotalPrice | currency("฿", 2) }}
                        </td>
                        <td class="text-center">
                          {{ oddTotalSum | currency("฿", 2) }}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  data() {
    var self = this;
    return {
      ordInvoiceNo: null,
      ordInvoiceDate: null,
      ordSupplier: null,
      ordStocks: null,
      ordFileName: null,
      ordDownloadUrl: null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Stock/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data != null && response.data.length > 0) {
            self.ordInvoiceNo = response.data[0].invoiceNo;
            self.ordInvoiceDate = response.data[0].invoiceDateFormat;
            self.ordSupplier = response.data[0].vendorName;
            self.ordFileName = response.data[0].fileName;
            // self.ordDownloadUrl =
            //   "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
            if (response.data[0].downloadUrl) {
              self.ordDownloadUrl =
                `/Api/File/FileDownloadByte?FileInfoId=${response.data[0].downloadUrl}&ContentType=${encodeURIComponent(response.data[0].contentType)}&FileName=${encodeURIComponent(response.data[0].fileName)}`;
            }
            self.ordStocks = response.data;
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  computed: {
    oddTotalQty() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (let i = 0; i < this.ordStocks.length; i++) {
          const stock = this.ordStocks[i];
          sum += stock.qty;
        }
      }
      return sum;
    },
    oddTotalPrice() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (let i = 0; i < this.ordStocks.length; i++) {
          const stock = this.ordStocks[i];
          sum += stock.price;
        }
      }
      return sum;
    },
    oddTotalSum() {
      var sum = 0;
      if (this.ordStocks != null && this.ordStocks.length > 0) {
        for (let i = 0; i < this.ordStocks.length; i++) {
          const stock = this.ordStocks[i];
          sum += stock.summaryItem;
        }
      }
      return sum;
    },
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Order/OrderDetail.vue